import { FunctionComponent, useEffect, useRef, useState } from "react";
import "./Package.scss";
import Table from "../../Components/Table/Table";
import CustomToolbar from "../../Components/Table/components/CustomToolbar";
import ButtonField from "../../Components/Button/ButtonField";
import { Columns } from "../../Components/Table/ITable";
import {
  GridRenderCellParams,
  GridValueFormatterParams,
} from "@mui/x-data-grid";
import { IPackagelist } from "./IPackage";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import Dialog from "../../Components/Dialog/Dialog";
import PackageForm from "./PackageForm";
import ResponseDialog from "../../Components/ResponseDialog/ResponseDialog";
import TableSearch from "../../Components/Table/components/TableSearch";
import { ReactComponent as Delete } from "../../Assets/Images/delete.svg";
import { ReactComponent as Edit } from "../../Assets/Images/edit.svg";
import { IDeleteDialog } from "../../Components/DeleteDialog/IDeleteDialog";
import IconButtonField from "../../Components/Button/IconButtonField";
import { SvgIcon } from "@mui/material";
import DeleteDialog from "../../Components/DeleteDialog/DeleteDialog";
import { ReactComponent as RefreshButton } from "../../Assets/Images/RefreshButton.svg";
import { listPackage } from "../../Redux/Slices/Package/ListPackageSlice";
import { addPackage, clearAddPackageResponse } from "../../Redux/Slices/Package/AddPackageSlice";
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import {
  clearDeletePackageResponse,
  deletePackage,
} from "../../Redux/Slices/Package/DeletePackageSlice";
import { clearEditPackageResponse } from "../../Redux/Slices/Package/EditPackageSlice";
import { listSideMenuPermission } from "../../Redux/Slices/SideMenuPermission/ListSideMenuPermissionSlice";
import { listExam } from "../../Redux/Slices/Exam/ListExamSlice";
import { listCourses } from "../../Redux/Slices/Courses/ListCoursesSlice";

import { listYearlevel_map } from "../../Redux/Slices/Yearlevel_map/ListYearlevel_mapSlice";

// Utility function for tick and cross marks
const renderTickCross = (value: boolean) => {
  return (
    <span className={value ? "tick-mark" : "cross-mark"}>
      {value ? "✓" : "✗"}
    </span>
  );
};

interface PackageProps { }

const Package: FunctionComponent<PackageProps> = () => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [deleteDialogData, setDeleteData] = useState<IDeleteDialog>({});
  const [initialValues, setInitialValues] = useState<IPackagelist | {}>({
    course_ids: [],
    status: true,
  });
  const dispatch = useAppDispatch();
  const { data: listPackages } = useAppSelector(
    (state) => state.ListPackageSlice
  );
  const { data: addPackageResponse } = useAppSelector(
    (state) => state.AddPackageSlice
  );
  const { data: EditPackage } = useAppSelector(
    (state) => state.EditPackageSlice
  );
  const { data: deletePackages } = useAppSelector(
    (state) => state.DeletePackage
  );

  const { data: listYearlevel_maps } = useAppSelector(
    (state) => state.ListYearlevel_mapSlice
  );

  // user permisssion
  const { data: userPermissionlist } = useAppSelector(
    (state) => state.SideMenuPermission
  );

  const to = "masters";

  const filteredList = userPermissionlist.Dashboard?.filter(
    (item: any) => item.to === to
  ) || [];
  const fliterdata: any = filteredList[0]?.items;
  const finaldata = fliterdata?.[5] || {};

  const formRef = useRef<HTMLFormElement>(null);
  const columns: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      width: 90,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name",
      renderHeader: () => <b>Package</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "package_duration",
      renderHeader: () => <b>Duration</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "cost",
      renderHeader: () => <b>Cost</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "yeargroup_str",
      renderHeader: () => <b>Year Group</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "domain",
      renderHeader: () => <b>Domain</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "description",
      renderHeader: () => <b>Description</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
      renderCell: (params) => <span>{params.value || "-"}</span>,
    },
    {
      field: "about",
      renderHeader: () => <b>About</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
      renderCell: (params) => <span>{params.value || "-"}</span>,
    },
    {
      field: "duration",
      renderHeader: () => <b>Duration (days)</b>,
      flex: 1,
      type: "number",
      headerAlign: "left",
      align: "left",
    },

    {
      field: "courses",
      renderHeader: () => <b>Courses</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
      renderCell: (params: GridRenderCellParams<IPackagelist>) => {
        const courses = params.row.courses || [];
        const content = courses.map((course: any) => course.course_name).join(", ") || "-";
        return <span>{content}</span>;
      },
    },
    {
      field: "admin_only",
      renderHeader: () => <b>Admin Only</b>,
      flex: 1,
      type: "boolean",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => renderTickCross(params.value),
    },
    {
      field: "recommended",
      renderHeader: () => <b>Recommended</b>,
      flex: 1,
      type: "boolean",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => renderTickCross(params.value),
    },
    {
      field: "features",
      renderHeader: () => <b>Features</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
      renderCell: (params: GridRenderCellParams<IPackagelist>) => {
        const features = params.row.features || [];
        const content = features
          .filter((feature: any) => feature.status === true)
          .map((feature: any) => feature.name)
          .join(", ") || "-";
        return <span>{content}</span>;
      },
    },
    {
      field: "billing_type",
      renderHeader: () => <b>Billing Type</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "rate_period",
      renderHeader: () => <b>Rate Period</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
    },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "string",
      headerAlign: "left",
      align: "left",
      cellClassName: (params) =>
        `activename ${params.row.status ? "active" : "inactive"}`,

      valueFormatter: (params) =>
        params.value === true ? "Active" : "Inactive",
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      renderCell: (params: GridRenderCellParams<IPackagelist>) => {
        return (
          <>
            <IconButtonField
              disabled={finaldata?.permissions?.edit === false}
              onClick={() => {
                setInitialValues({ ...params.row, id: params.id as number });
                setIsEdit(true);
                setDialogOpen(true);
              }}
            >
              <SvgIcon sx={{ fill: "none" }} component={Edit} inheritViewBox />
            </IconButtonField>
            <IconButtonField
              toolTip="Duplicate"
              disabled={finaldata?.permissions?.add === false}
              onClick={() => {
                const duplicatedRow = { ...params.row };
                delete duplicatedRow.id;
                delete (duplicatedRow as any).index;
                delete duplicatedRow.yeargroup_id;
                duplicatedRow.name = `${duplicatedRow.name}-1`;
                setInitialValues(duplicatedRow);
                setDialogOpen(true);
              }}
            >
              <LibraryAddIcon sx={{ fontSize: 20, color: "#4785ff" }} />
            </IconButtonField>
            <IconButtonField
              disabled={finaldata?.permissions?.delete === false}
              onClick={() => {
                setDeleteData({ id: params.id, name: params?.row?.name });
                setDeleteDialogOpen(true);
              }}
            >
              <SvgIcon component={Delete} inheritViewBox />
            </IconButtonField>
          </>
        );
      },
    },
  ];

  const Package = Array.isArray(listPackages?.data)
    ? listPackages?.data.map((user, index) => ({ ...user, index: index + 1 }))
    : [];

  useEffect(() => {
    dispatch(listCourses());
    dispatch(listPackage());
    dispatch(listYearlevel_map());
    // dispatch(listSideMenuPermission());
  }, [addPackageResponse, EditPackage, deletePackages, dispatch]);
  useEffect(() => {
    return () => {
      dispatch(clearAddPackageResponse());
      dispatch(clearEditPackageResponse());
      dispatch(clearDeletePackageResponse());
    };
  }, [dispatch]);
  return (
    <>
      <Table rows={Package ?? []} columns={columns} exportFileName="Packages">
        <CustomToolbar>
          <h6></h6>
          <TableSearch />
          <ButtonField
            className="tabel_add_new_button"
            onClick={() => {
              setInitialValues({
                course_ids: [],
                status: true,
              });
              setIsEdit(false);
              setDialogOpen(true);
            }}
            toolTip="Add new"
            disabled={finaldata?.permissions?.add === false}
          >
            Add new
          </ButtonField>
          <IconButtonField
            className="refresh_btn"
            toolTip="Refresh"
            onClick={() => dispatch(listPackage())}
          >
            <SvgIcon
              className="refresh_svg_icon"
              component={RefreshButton}
              inheritViewBox
            />
          </IconButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={dialogOpen}
        dialogClassName="dialog_double_input"
        Dialog_Title={`${isEdit ? "Update" : "Add"} Package`}
        Dialog_Content={
          <PackageForm
            formRef={formRef}
            initialValues={initialValues}
            setInitialValues={setInitialValues}
          />
        }
        Dialog_Actions={
          <>
            <ButtonField
              className="form_cancel_button"
              onClick={() => {
                setDialogOpen(false);
                setIsEdit(false);
                setInitialValues({
                  course_ids: [],
                  status: true,
                });
              }}
            >
              Cancel
            </ButtonField>
            <ButtonField
              className="form_save_button"
              onClick={() => formRef.current?.requestSubmit()}
            >
              Save
            </ButtonField>
          </>
        }
      />
      <ResponseDialog response={addPackageResponse} parentDialog={setDialogOpen} />
      <ResponseDialog response={EditPackage} parentDialog={setDialogOpen} />
      <DeleteDialog
        deleteableName={deleteDialogData.name ?? ""}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        deleteFunction={() => {
          dispatch(deletePackage(deleteDialogData.id));
        }}
        response={deletePackages}
      />
    </>
  );
};

export default Package;
